import { useTagExplainSearchAction } from './use-tag-explain-search-action'

export function useExplainSearchBox(): void {
  useTagExplainSearchAction()
}
